// extracted by mini-css-extract-plugin
export var subtitleItem = "blog-post-module--subtitleItem--15eb6";